import { InfoTip } from './InfoTip'
import './infoTip.css'

/**
 * Единственная справка экрана: ⓘ сверху слева, рядом с «Назад» или заголовком. Нажал — несколько коротких строк
 * обычными словами: что это за экран и что тут делать. Без технических слов и без описания каждой кнопки.
 * Внутри экрана рядом ставится `ActionInfoQuiet`, чтобы у отдельных кнопок своих ⓘ не было.
 */
export function ScreenInfo({ title, lines }: { title: string; lines: readonly string[] }) {
  return (
    <span className="krp-screen-info">
      <InfoTip label={title}>
        {lines.map((line) => (
          <span key={line}>{line}</span>
        ))}
      </InfoTip>
    </span>
  )
}
